import { IUserState } from 'redux/user/user.slice.type';
import { useAppSelector } from 'store/hooks';

export const useCurrentUser = (): IUserState => {
  return useAppSelector((state) => state.user);
};
